export const nowSecs = (): number => Math.floor(Date.now() / 1000);

export type Preset = "1h" | "6h" | "24h" | "7d" | "30d" | "all";

export const PRESETS: readonly Preset[] = ["1h", "6h", "24h", "7d", "30d", "all"];

export const PRESET_SECS: Record<Exclude<Preset, "all">, number> = {
  "1h": 3600,
  "6h": 6 * 3600,
  "24h": 86400,
  "7d": 7 * 86400,
  "30d": 30 * 86400,
};

export function isPreset(s: string): s is Preset {
  return (PRESETS as readonly string[]).includes(s);
}
